import React, { useState, useEffect, useRef } from "react";
import { Select, DatePicker } from "antd";
import moment from "moment";
import JobStatusService from "../../../Services/JobStatusService";
import Repeater from "./Repeater";
import ExpRepeater from "./ExpRepeater";
import DataParser from "../../../utlits/Dataparser";
import { Link, useNavigate, useParams } from "react-router-dom";
import CompanyService from "../../../Services/CompanyService";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import DesignationService from "../../../Services/DesignationService";
import { NATIONALITIES, BLOOD_GROUPS, RELIGIONS } from "../../../utlits/constants";

const { Option } = Select;

const ViewUser = () => {
  const params = useParams();
  const navigate = useNavigate();
  const id = params.id;

  const [inputFields, setInputFields] = useState([
    { degree_title: "", institue: "", end_date: "", cert_picture: null },
  ]);
  const [ExpInputFields, setExpInputFields] = useState([
    { organization_title: "", designation: "", start_date: "", end_date: "", last_salary: "" },
  ]);

  const addExpFiled = () => setExpInputFields([...ExpInputFields, { organization_title: "", designation: "", start_date: "", end_date: "", last_salary: "" }]);
  const addFields = () => setInputFields([...inputFields, { degree_title: "", institue: "", end_date: "", cert_picture: null }]);

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  const [userShifts, setUserShifts] = useState("");
  const [BusinessPhone, setBusinessPhone] = useState("");
  const [personalMobile, setPersonalMobile] = useState("");
  const [spouse, setSpouse] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [landLine, setLandline] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [nationality, setNationality] = useState("");
  const [emergencyContactName, setEmergencyContactName] = useState("");
  const [emergencyContactPhone, setEmergenctContactPhone] = useState("");
  const [dob, setDob] = useState("");
  const [cnic, setCnic] = useState("");
  const [spouseCnic, setSpouseCnic] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [religion, setReligion] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [personPic2, setPersonalPic2] = useState(null);
  const [department, setDepartment] = useState("");
  const [isHead, setIsHead] = useState("");
  const [phoneExt, setPhoneExt] = useState("");
  const [relativeInWebsouls, setRealtionInWebsouls] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [dateOfjoining, setDateofJoining] = useState("");
  const [reportsTo, setReportsTo] = useState("");
  const [designation, setDesignation] = useState("");
  const [empid, setEmpId] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [preview, setPreview] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const TABS = [
    { label: "Login Credentials", icon: "uil-lock" },
    { label: "Personal Info", icon: "uil-user-circle" },
    { label: "Official Info", icon: "uil-briefcase" },
    { label: "Academic Records", icon: "uil-graduation-cap" },
    { label: "Work Experience", icon: "uil-suitcase" },
    { label: "Documents", icon: "uil-paperclip" },
  ];

  const [rolesList, setRolesList] = useState([]);
  const [deparmentList, setDepartmentList] = useState([]);
  const [ReportList, setReportList] = useState([]);
  const [employmentStatusList, setEmploymentStatusList] = useState([]);
  const [designationList, setDesignationList] = useState([]);

  const fileInputRef = useRef(null);
  const fileInputRefMul = useRef(null);

  // kept for ExpRepeater
  const customStyles = {
    control: (provided, state) => ({ ...provided, border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #e1e5eb", borderRadius: "10px", minHeight: "40px", height: "40px", boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(13, 223, 171, 0.25)" : "none", fontSize: "14px", "&:hover": { border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #e1e5eb" } }),
    valueContainer: (provided) => ({ ...provided, padding: "0 15px", height: "40px", display: "flex", alignItems: "center" }),
    input: (provided) => ({ ...provided, margin: "0px", padding: "0px", caretColor: "black", color: "black", boxShadow: "none !important", outline: "none !important", border: "none !important", background: "transparent" }),
    singleValue: (provided) => ({ ...provided, margin: "0px" }),
    indicatorsContainer: (provided) => ({ ...provided, height: "40px" }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#0DDFAB" : state.isFocused ? "rgba(13, 223, 171, 0.1)" : "transparent", color: state.isSelected ? "white" : "black", cursor: "pointer", "&:active": { backgroundColor: "#0DDFAB" }, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const designationOptions = designationList.map((el) => ({ value: el.name, label: el.name }));

  const fileIcons = { pdf: "📕", doc: "📘", docx: "📘", xls: "📗", xlsx: "📗", csv: "📗", txt: "📄", default: "📁" };

  useEffect(() => {
    if (id) {
      const CompanyId = DataParser.CompanyId();

      CompanyService.viewComapnyUser(id, CompanyId).then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }

        const userDetails = res.data.user[0];
        const userAcademic = res.data.academic;
        const userExperice = res.data.experience;
        const userdoc = res.data.docss;

        if (userdoc && userdoc.length > 0) {
          const backendPath = process.env.REACT_APP_USER_DOCS_PATH;
          const existingAttachments = userdoc.map((doc) => {
            const fileName = doc.user_docss;
            const filePath = `${backendPath}${fileName}`;
            const ext = fileName.split(".").pop().toLowerCase();
            const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
            return { _id: doc._id, file: fileName, preview: isImage ? filePath : null, type: isImage ? "image" : "doc" };
          });
          setAttachments(existingAttachments);
        }

        setEmail(userDetails.email);
        setFirstName(userDetails.first_name);
        setLastName(userDetails.last_name);
        setGender(userDetails.gender || "");
        setRole(userDetails.role);
        setSpouse(userDetails.spouse_name);
        setBusinessPhone(userDetails.buisness_phone);
        setPersonalEmail(userDetails.personal_email);
        setPersonalMobile(userDetails.personal_mobile);
        setLandline(userDetails.personal_land_line_no);
        setCurrentAddress(userDetails.personal_current_address);
        setPermanentAddress(userDetails.personal_permanent_address);
        setNationality(userDetails.personal_nationality);
        setEmergencyContactName(userDetails.personal_emg_contact_name);
        setEmergenctContactPhone(userDetails.personal_emg_contact_phone);
        setDob(userDetails.dob || "");
        setCnic(userDetails.personal_cnic);
        setSpouseCnic(userDetails.personal_parent_cnic);
        setMaritalStatus(userDetails.personal_marital_status);
        setReligion(userDetails.personal_religion);
        setIsHead(userDetails.is_head);
        setBloodGroup(userDetails.personal_blood_group);
        setDepartment(userDetails.department);
        setPhoneExt(userDetails.phone_ext);
        setRealtionInWebsouls(userDetails.relative_websouls);
        setEmploymentStatus(userDetails.employment_status);
        setDateofJoining(userDetails.joining_date);
        setReportsTo(userDetails.report_to);
        setDesignation(userDetails.designation || "");
        setEmpId(userDetails.empid || "");
        setPersonalPic2(userDetails.image);
        setUserShifts(userDetails?.userShifts);
        setExpInputFields(userExperice || []);

        setInputFields(
          (userAcademic || []).map((item) => ({
            ...item,
            cert_picture_preview: item.cert_picture
              ? process.env.REACT_APP_USER_DOCS_PATH + item.cert_picture
              : null,
          }))
        );

        CompanyService.getCompanyRoles(CompanyId).then((res) => {
          if (res.data !== "Un-Athunticated request") setRolesList(res.data.roles || []);
        });
      });

      CompanyService.getCompanyDepartment(CompanyId).then((res) => {
        if (res.data !== "Un-Athunticated request") setDepartmentList(res.data.departments || []);
      });
      CompanyService.getCompanyReportsTo(CompanyId).then((res) => {
        if (res.data !== "Un-Athunticated request") setReportList(res.data.user || []);
      });
      JobStatusService.getJobStatusService(CompanyId).then((res) => {
        if (res.data !== "Un-Athunticated request") setEmploymentStatusList(res.data.jobstatus || []);
      });
      DesignationService.getCompanyDesignation(CompanyId).then((res) => {
        if (res.data !== "Un-Athunticated request") setDesignationList(res.data?.designations || []);
      });
    }
  }, [id]);

  const sectionHeader = (icon, title) => (
    <h5 className="mb-3" style={{ borderBottom: "2px solid #0bc698", paddingBottom: "8px", fontWeight: 700, color: "#000" }}>
      <i className={`${icon} me-2`}></i>{title}
    </h5>
  );

  return (
    <>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-between" style={{ padding: "8px 0" }}>
                  <h4 className="mb-0">View Employee</h4>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/${DataParser.CompanyIdentifierRole()}/users`}>All Employees</Link>
                    </li>
                    <li className="breadcrumb-item active">View Employee</li>
                  </ol>
                </div>
              </div>
            </div>
            {/* ── Tab Bar ── */}
            <div className="user-form-tab-bar" style={{ marginTop: "16px" }}>
              <div style={{ display: "flex", flex: 1 }}>
                {TABS.map((tab, i) => (
                  <div key={i} className={`user-form-tab${activeTab === i ? " active" : ""}`} onClick={() => setActiveTab(i)}>
                    <i className={tab.icon} />
                    {tab.label}
                  </div>
                ))}
              </div>
              {activeTab < TABS.length - 1 && (
                <button type="button" onClick={() => setActiveTab(activeTab + 1)} style={{ background: "#1D1D1D", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}>
                  Next
                </button>
              )}
            </div>

            <div className="row">
              <div className="col-12 px-0">
                <div className="card" style={{ backgroundColor: "transparent", boxShadow: "none", border: "none" }}>
                  <div className="card-body" style={{ padding: "0" }}>

                    {activeTab === 0 && (<>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="float-input-wrap mb-3">
                          <input type="email" id="view-email" placeholder=" " disabled value={email} />
                          <label htmlFor="view-email">Login Email</label>
                        </div>
                      </div>
                    </div>
                    </>)}

                    {activeTab === 1 && (<>
                    <div className="row">
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-firstName" placeholder=" " disabled value={firstName} />
                          <label htmlFor="view-firstName">First Name</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-lastName" placeholder=" " disabled value={lastName} />
                          <label htmlFor="view-lastName">Last Name</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${gender ? "has-value" : ""}`}>
                          <label>Gender</label>
                          <Select value={gender || undefined} placeholder="" style={{ width: "100%" }} disabled>
                            <Option value="Male">Male</Option>
                            <Option value="Female">Female</Option>
                            <Option value="Other">Other</Option>
                          </Select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-spouse" placeholder=" " disabled value={spouse} />
                          <label htmlFor="view-spouse">Spouse or Father's Name</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="email" id="view-personalEmail" placeholder=" " disabled value={personalEmail} />
                          <label htmlFor="view-personalEmail">Personal Email</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-personalMobile" placeholder=" " disabled value={personalMobile} />
                          <label htmlFor="view-personalMobile">Personal Mobile</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-landLine" placeholder=" " disabled value={landLine} />
                          <label htmlFor="view-landLine">Landline</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-currentAddress" placeholder=" " disabled value={currentAddress} />
                          <label htmlFor="view-currentAddress">Current Address</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-permanentAddress" placeholder=" " disabled value={permanentAddress} />
                          <label htmlFor="view-permanentAddress">Permanent Address</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${nationality ? "has-value" : ""}`}>
                          <label>Nationality</label>
                          <Select value={nationality || undefined} placeholder="" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {NATIONALITIES.map((nat) => <Option key={nat} value={nat}>{nat}</Option>)}
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-emergencyName" placeholder=" " disabled value={emergencyContactName} />
                          <label htmlFor="view-emergencyName">Emergency Contact Name</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-emergencyPhone" placeholder=" " disabled value={emergencyContactPhone} />
                          <label htmlFor="view-emergencyPhone">Emergency Contact Phone</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${dob ? "has-value" : ""}`}>
                          <label>Date Of Birth</label>
                          <DatePicker
                            style={{ width: "100%" }}
                            format="DD-MM-YYYY"
                            placeholder=""
                            value={dob ? moment(dob, "YYYY-MM-DD") : null}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-cnic" placeholder=" " disabled value={cnic} />
                          <label htmlFor="view-cnic">CNIC</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-spouseCnic" placeholder=" " disabled value={spouseCnic} />
                          <label htmlFor="view-spouseCnic">Parent/Spouse CNIC</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${maritalStatus ? "has-value" : ""}`}>
                          <label>Marital Status</label>
                          <Select value={maritalStatus || undefined} placeholder="" style={{ width: "100%" }} disabled>
                            <Option value="Single">Single</Option>
                            <Option value="Married">Married</Option>
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${religion ? "has-value" : ""}`}>
                          <label>Religion</label>
                          <Select value={religion || undefined} placeholder="" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {RELIGIONS.map((rel) => <Option key={rel} value={rel}>{rel}</Option>)}
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${bloodGroup ? "has-value" : ""}`}>
                          <label>Blood Group</label>
                          <Select value={bloodGroup || undefined} placeholder="" style={{ width: "100%" }} disabled>
                            {BLOOD_GROUPS.map((bg) => <Option key={bg} value={bg}>{bg}</Option>)}
                          </Select>
                        </div>
                      </div>
                      {personPic2 && (
                        <div className="col-12 col-sm-4">
                          <div className="mb-3">
                            <label className="form-label" style={{ fontSize: "12px", fontWeight: 600, color: "#000" }}>Profile Picture</label>
                            <div>
                              <img
                                src={`${process.env.REACT_APP_USER_DOCS_PATH}${encodeURIComponent(personPic2)}`}
                                alt="Profile"
                                style={{ width: "60px", height: "72px", objectFit: "cover", borderRadius: "6px", border: "1px solid #ddd", cursor: "pointer" }}
                                onClick={() => window.open(`${process.env.REACT_APP_USER_DOCS_PATH}${encodeURIComponent(personPic2)}`, "_blank")}
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    </>)}

                    {activeTab === 2 && (<>
                    <div className="row">
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${role ? "has-value" : ""}`}>
                          <label>Role</label>
                          <Select value={role || undefined} placeholder="" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {rolesList.map((el) => (
                              <Option key={el.id} value={el.id}>{el.name}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="text" id="view-empid" placeholder=" " disabled value={empid} />
                          <label htmlFor="view-empid">Employee ID</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${department ? "has-value" : ""}`}>
                          <label>Department</label>
                          <Select value={department || undefined} placeholder="" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {deparmentList && deparmentList.map((el) => (
                              <Option key={el.id} value={el.id}>{el.name}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${designation ? "has-value" : ""}`}>
                          <label>Designation</label>
                          <Select value={designation || undefined} placeholder="" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {designationList.map((el) => (
                              <Option key={el.name} value={el.name}>{el.name}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-select-wrap mb-3">
                          <label>Is Head</label>
                          <Select value={isHead || undefined} placeholder="—" style={{ width: "100%" }} disabled>
                            <Option value="yes">Yes</Option>
                            <Option value="no">No</Option>
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-businessPhone" placeholder=" " disabled value={BusinessPhone} />
                          <label htmlFor="view-businessPhone">Business Phone</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-input-wrap mb-3">
                          <input type="tel" id="view-phoneExt" placeholder=" " disabled value={phoneExt} />
                          <label htmlFor="view-phoneExt">Phone Ext.</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-select-wrap mb-3">
                          <label>Any Relative in Websouls?</label>
                          <Select value={relativeInWebsouls || undefined} placeholder="—" style={{ width: "100%" }} disabled>
                            <Option value="yes">Yes</Option>
                            <Option value="no">No</Option>
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-select-wrap mb-3">
                          <label>Employment Status</label>
                          <Select value={employmentStatus || undefined} placeholder="—" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {employmentStatusList && employmentStatusList.map((elsa) => (
                              <Option key={elsa.id} value={elsa.id}>{elsa.name}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="float-select-wrap mb-3">
                          <label>Date of Joining</label>
                          <DatePicker
                            style={{ width: "100%" }}
                            format="DD-MM-YYYY"
                            value={dateOfjoining ? moment(dateOfjoining, "YYYY-MM-DD") : null}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className={`float-select-wrap mb-3 ${reportsTo ? "has-value" : ""}`}>
                          <label>Report To</label>
                          <Select value={reportsTo || undefined} placeholder="" style={{ width: "100%" }} disabled showSearch filterOption={(input, option) => String(option.children).toLowerCase().includes(input.toLowerCase())}>
                            {ReportList && ReportList.map((el) => (
                              <Option key={el.id} value={el.id}>{el.first_name} {el.last_name}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>
                    </>)}

                    {activeTab === 3 && (<>
                    <div className="row">
                      <div className="repeater-default">
                        <Repeater
                          disabled={true}
                          inputFields={inputFields}
                          setInputFields={setInputFields}
                          addFields={addFields}
                        />
                      </div>
                    </div>
                    </>)}

                    {activeTab === 4 && (<>
                    <div className="row">
                      <div className="repeater-default">
                        <ExpRepeater
                          disabled={true}
                          ExpInputFields={ExpInputFields}
                          setExpInputFields={setExpInputFields}
                          designationOptions={designationOptions}
                          customStyles={customStyles}
                        />
                      </div>
                    </div>
                    </>)}

                    {activeTab === 5 && (<>
                    {attachments.length > 0 ? (
                      <div className="row mb-4">
                        <div className="col-12">
                          <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                            {attachments.map((att, index) => {
                              const fileName = typeof att.file === "string" ? att.file : att.file.name;
                              const backendPath = process.env.REACT_APP_USER_DOCS_PATH;
                              const src = att.preview || (typeof att.file === "string" ? `${backendPath}${att.file}` : null);
                              const handleDownload = () => {
                                if (!src) return;
                                const link = document.createElement("a");
                                link.href = src;
                                link.download = fileName;
                                link.click();
                              };
                              return (
                                <div
                                  key={index}
                                  title={fileName}
                                  style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#1e2030", borderRadius: "5px", padding: "5px 12px", fontSize: "13px", color: "#0bc698", maxWidth: "240px", fontWeight: 500, cursor: "pointer" }}
                                  onClick={handleDownload}
                                >
                                  <i className="uil-import" style={{ fontSize: "14px", flexShrink: 0 }} />
                                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                    {fileName}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p style={{ color: "#6c757d", fontSize: "14px" }}>No attachments uploaded.</p>
                    )}
                    </>)}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewUser;
